import React, { FC, useRef } from 'react';
import ASSETS from '../../assets';

interface IProps {
  question: string;
  answer: string;
}

const Accordion: FC<IProps> = ({ question, answer }) => {
  const panel = useRef<HTMLDivElement>(null);
  const arrow = useRef<HTMLImageElement>(null);

  const handleAccordion = () => {
    if (panel.current && arrow.current) {
      if (panel.current.style.maxHeight > '0px') {
        panel.current.style.maxHeight = '0px';
        panel.current.classList.remove('open');
        arrow.current.style.rotate = '0deg';
      } else {
        panel.current.style.maxHeight = panel.current.scrollHeight + 'px';
        panel.current.classList.add('open');
        arrow.current.style.rotate = '45deg';
      }
    }
  };
  return (
    <div
      className='w-full bg-l-light-grey p-6 rounded-[16px]'
      onClick={handleAccordion}
    >
      <div className='flex items-center justify-between'>
        <p className='md:text-xl text-lg text-l-primary font-semibold'>
          {question}
        </p>
        <img
          src={ASSETS.plus}
          ref={arrow}
          className='cursor-pointer transition-all duration-300'
          alt=''
        />
      </div>
      <div
        className='panel max-h-0 overflow-hidden transition-all duration-300'
        ref={panel}
      >
        <div className='pt-6'>
          <p className='md:text-base text-sm text-l-primary'>{answer}</p>
        </div>
      </div>
    </div>
  );
};

export default Accordion;
